import axios from "axios";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    extras: [],
    extra: {},
  },
  mutations: {
    llenarExtras(state, data) {
      state.extras = data;
    },
    llenarExtra(state, data) {
      state.extra = data;
    },
  },
  actions: {
    getExtras: async function({ commit }, token) {
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;

      await axios
        .get("extra/list", configuracion)
        .then(function(response) {
          response.data.forEach((element) => {
            element.createdAt = moment(element.createdAt).format("LL");
          });
          data = response.data;
          commit("llenarExtras", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getExtra: async function({ commit }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      let d = null;

      await axios
        .get(`extra/query?id=${data.id}`, configuracion)
        .then(function(response) {
          d = response.data.detalles;
          commit("llenarExtra", d);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    saveExtra: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      debugger;

      await axios
        .post(
          "extra/add",
          {
            usuario: data.usuario,
            nombre: data.obj.nombre,
          },
          configuracion
        )
        .then(function(res) {
          dispatch("getExtras", data.token);
          swal({
            title: "Buen trabajo!",
            text: `El extra ${res.data.nombre} fue agregado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    updateExtra: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      debugger;
      await axios
        .put(
          "extra/update",
          {
            id: data.obj.id,
            usuario: data.usuario,
            nombre: data.obj.nombre,
          },
          configuracion
        )
        .then(function(res) {
          dispatch("getExtras", data.token);
          swal({
            title: "Buen trabajo!",
            text: `El extra ${res.data.nombre} fue editado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    deleteExtra: async function({ dispatch }, data) {
      let token = data.token;
      let header = { Token: token };
      let configuracion = { headers: header };
      //debugger
      await axios
        .delete(`extra/remove?id=${data.id}`, configuracion)
        .then(function() {
          dispatch("getExtras", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Extra eliminado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
          console.log(error);
        });
    },
  },
};
